// extracted by mini-css-extract-plugin
module.exports = {"BannerContainer":"BannerContainer_BannerContainer__1ywPh","BannerDesk":"BannerContainer_BannerDesk__QDBnw","BannerMob":"BannerContainer_BannerMob__1ZDfd"};